import { Component, OnInit, ViewChild, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAccountPersonRequest, PaymentMethod, RIQPaymentRequest } from 'src/app/models/PaymentModels';
import { NgForm } from '@angular/forms';
import { PaymentsService } from 'src/app/services/payments.service';
import { ToastrService } from 'ngx-toastr';
import { ChannelEvent, ChannelService } from 'src/app/services/channel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AssignPaymentMethodComponent } from '../assign-payment-method/assign-payment-method.component';
import { AddPaymentMethodComponent } from '../add-payment-method/add-payment-method.component';
import { ClientInvoiceRow, InvoiceHistoryModel } from 'src/app/models/InvoiceHistoryModels';
import { PaymentMethodListComponent } from '../payment-method-list/payment-method-list.component';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-one-time-payment-modal',
  templateUrl: './one-time-payment-modal.component.html',
  styleUrls: ['./one-time-payment-modal.component.less']
})
export class OneTimePaymentModalComponent implements OnInit, AfterViewInit {

  @Input() clientId: number;
  @Input() propertyId: number;
  @Input() invoiceHistory: ClientInvoiceRow;
  @Output() paymentProcessed: EventEmitter<boolean> = new EventEmitter()
  @ViewChild('PmtForm', {}) pmtForm: NgForm;
  @ViewChild('addPmtForm', {}) addPmtForm: AddPaymentMethodComponent;
  @ViewChild('pmtListForm', {}) pmtListForm: PaymentMethodListComponent;
  aptexxCreatePaymentLink: string;
  selectedPmtMethod: PaymentMethod;
  showButtons: boolean = true;
  currentStage: OneTimePaymentFlowPage = OneTimePaymentFlowPage.SelectMethod;
  paymentRequest: RIQPaymentRequest = new RIQPaymentRequest();
  paymentResponse: any;
  public get selectedPmtMethodId(): number {
    if (!this.selectedPmtMethod) return 0;
    return this.selectedPmtMethod.id;
  }


  constructor(public modalService: NgbModal, public payments: PaymentsService, private toast: ToastrService, private channels: ChannelService, public sanitizer: DomSanitizer) { }
  ngAfterViewInit(): void {
    this.payments.LoadUserPaymentMethods(this.propertyId,this.clientId);
    this.pmtListForm.pmtMethodSelectedEvt.subscribe(pmt => {
      this.selectedPmtMethod = pmt;
    });
  }

  ngOnInit() {
   
  }

  cancel(): void {
    this.payments.processing = false;
    this.modalService.dismissAll();
  }

  save(): void {
    if (this.currentStage == OneTimePaymentFlowPage.AddMethod) {
      if (!this.addPmtForm.ngForm.valid) {
        this.toast.error('Validation errors exist.', '', { disableTimeOut: true, closeButton: true });
        return;
      }

      this.addPmtForm.save();

    } else if (this.currentStage == OneTimePaymentFlowPage.SelectMethod) {

      if (this.payments.paymentMethods.filter(pmt => { return pmt.selected; }).length == 0) {
        this.toast.error('Please select a payment method to make your payment');
        return;
      }
      this.paymentRequest.accountPersonId = this.selectedPmtMethod.vendorAccountId;
      this.paymentRequest.amount = Math.round(this.invoiceHistory.totalAmount * 100);
      this.paymentRequest.methodId = this.selectedPmtMethod.methodId;
      this.paymentRequest.invoiceHistoryId = this.invoiceHistory.invoiceNumber;
      this.currentStage = OneTimePaymentFlowPage.VerifyPaymentDetails;

    } else if (this.currentStage == OneTimePaymentFlowPage.VerifyPaymentDetails) {
      if(!this.pmtForm.valid) {
        this.toast.error('Please provide atleast 1 recipient email address to continue.');
        return;
      }
      this.payments.sendPayment(this.paymentRequest).subscribe((rsp: any) => {
        this.paymentResponse = rsp;
        this.payments.processing = false;
        this.showButtons = false;
        this.currentStage = OneTimePaymentFlowPage.PaymentSummary;
        this.paymentProcessed.next(true);
      });
    }

  }

  tryAgain(){
    this.selectedPmtMethod = undefined;
    this.showButtons = true;
    this.paymentRequest = undefined;
    this.currentStage = OneTimePaymentFlowPage.SelectMethod;
  }

  pmtMethodAdded(pmt: PaymentMethod) {
    this.showButtons = true;
    this.selectedPmtMethod = pmt;
    this.currentStage = OneTimePaymentFlowPage.SelectMethod;
  }

}

export enum OneTimePaymentFlowPage {
  SelectMethod,
  AddMethod = 1,
  AssignMethod = 2,
  VerifyPaymentDetails = 3,
  PaymentSummary = 4
}
